module.exports = __webpack_public_path__ + "static/4_KeyPair-668adc7dcaada8b825cbb6ed0917ac0a.jpg";